/** Stable URL slugs for insight detail routes (`/analytics/insights/:insightId/detail`). */
export const InsightId = {
    PUDO_STALE_PICK_UPS: 'pudo-stale-pick-ups',
    PUDO_STALE_DROP_OFFS: 'pudo-stale-drop-offs',
    PUDO_SLOWEST_DROP_OFF_USERS: 'pudo-slowest-drop-off-users',
    PUDO_SLOWEST_PICK_UP_USERS: 'pudo-slowest-pick-up-users',
    PUDO_TRANSACTIONS_PER_SENDER: 'pudo-transactions-per-sender',
    PUDO_TRANSACTIONS_PER_RECEIVER: 'pudo-transactions-per-receiver',
    PUDO_TRANSACTIONS_BY_SPOT: 'pudo-transactions-by-spot',
    PUDO_DAILY_TURNOVER_RATE: 'pudo-daily-turnover-rate',
    PUDO_COMPARTMENT_USAGE_BY_SIZE: 'pudo-compartment-usage-by-size',
    PUDO_ACTIVITY_WEEKDAY_HEATMAP: 'pudo-activity-weekday-heatmap',
    PUDO_ACTIVITY_HOUR_DAY_HEATMAP: 'pudo-activity-hour-day-heatmap',
    NIVALIZ_URNS_STALE_DROP_OFFS: 'nivaliz-urns-stale-drop-offs',
    NIVALIZ_URNS_STALE_PICK_UPS: 'nivaliz-urns-stale-pick-ups',
    NIVALIZ_COFFINS_STALE_DROP_OFFS: 'nivaliz-coffins-stale-drop-offs',
    NIVALIZ_COFFINS_STALE_PICK_UPS: 'nivaliz-coffins-stale-pick-ups',
    NIVALIZ_DAILY_TURNOVER_RATE: 'nivaliz-daily-turnover-rate',
    NIVALIZ_COMPARTMENT_USAGE_BY_SIZE: 'nivaliz-compartment-usage-by-size',
    NIVALIZ_URNS_ACTIVITY_WEEKDAY_HEATMAP: 'nivaliz-urns-activity-weekday-heatmap',
    NIVALIZ_COFFINS_ACTIVITY_WEEKDAY_HEATMAP: 'nivaliz-coffins-activity-weekday-heatmap',
    NIVALIZ_URNS_ACTIVITY_HOUR_DAY_HEATMAP: 'nivaliz-urns-activity-hour-day-heatmap',
    NIVALIZ_COFFINS_ACTIVITY_HOUR_DAY_HEATMAP: 'nivaliz-coffins-activity-hour-day-heatmap',
    VENDING_PRODUCT_POPULARITY: 'vending-product-popularity',
    VENDING_TIME_TO_STOCKOUT: 'vending-time-to-stockout',
    VENDING_TOP_CONSUMERS: 'vending-top-consumers',
    VENDING_PEAK_CONSUMPTION_WINDOWS: 'vending-peak-consumption-windows',
    VENDING_REPLENISHMENT_ACTIVITY_HOUR_DAY_HEATMAP: 'vending-replenishment-activity-hour-day-heatmap',
    VENDING_RECYCLE_SLOTS_FILL_RATE: 'vending-recycle-slots-fill-rate',
    VENDING_LONGEST_REVIEW_WAITS: 'vending-longest-review-waits',
    LENDING_EQUIPMENT_POPULARITY: 'lending-equipment-popularity',
    LENDING_AVERAGE_DURATION: 'lending-average-duration',
    LENDING_ASSET_USAGE_HOURS: 'lending-asset-usage-hours',
    LENDING_PEAK_CHECKOUT_WINDOWS: 'lending-peak-checkout-windows',
    LENDING_PEAK_RETURN_WINDOWS: 'lending-peak-return-windows',
    LENDING_OUTGOING_HEATMAP: 'lending-outgoing-heatmap',
    LENDING_INCOMING_HEATMAP: 'lending-incoming-heatmap',
    LENDING_USAGE_COUNT_LAST_MONTH: 'lending-usage-count-last-month',
    HARDWARE_UPTIME_OVER_TIME: 'hardware-uptime-over-time',
    HARDWARE_STATUS_MIX_OVER_TIME: 'hardware-status-mix-over-time',
    HARDWARE_UPTIME_BY_TYPE: 'hardware-uptime-by-type',
    HARDWARE_FLEET_BY_TYPE: 'hardware-fleet-by-type',
    HARDWARE_UPTIME_WEEKDAY_PATTERN: 'hardware-uptime-weekday-pattern'
} as const;

export type InsightIdValue = (typeof InsightId)[keyof typeof InsightId];
